import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControlDirective } from '@supoui/shared/components/abstract-control.directive';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-input-toggle',
    templateUrl: './input-toggle.component.html',
    styleUrls: ['./input-toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: forwardRef(() => InputToggleComponent),
            multi: true
        }
    ],
    standalone: false
})
export class InputToggleComponent extends AbstractControlDirective {
  public toggleControl: UntypedFormControl = new UntypedFormControl();

  @Input() name: string;

  public disabled = false;

  constructor() {
    super();
    this.subscriptions.push(
      this.toggleControl.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  public writeValue(value: string | null): void {
    value = value === undefined ? null : value;
    this.toggleControl.patchValue(value, { emitEvent: false });
  }

  public setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.toggleControl.disable({ emitEvent: false });
    } else {
      this.toggleControl.enable({ emitEvent: false });
    }
  }
}
